import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { TaskListService } from 'src/app/core/http/taskList/task-list.service';
import { SchemaService } from 'src/app/shared/services/schema/schema.service';
import { PollService } from 'src/app/core/http/poll/poll.service';

@Component({
  selector: 'fields-widget',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.css']
})
export class FieldsComponent implements OnInit {
  @Input() formFields;
  @Input() parentId;
  @Input() module;
  @Output() public NewSchema = new EventEmitter();
  fieldForm: FormGroup;

  constructor(private taskListService: TaskListService,private schemaService: SchemaService,  private _fb: FormBuilder, private pollService: PollService) { }

  ngOnInit(): void {
    
    this.fieldForm = this._fb.group({
      name:[''],
      schema: this._fb.group({
        title:[''],
        type:[''],
        description: [''],
        widget: this._fb.group({
          id: ['text']
        })
      })
    })
  }

  createForm(field) {
    field.schema = JSON.parse(field.schema);
    this.fieldForm = this._fb.group({
      name: [field.name],
      schema: this._fb.group({
        title:[field.schema.title],
        type:[field.schema.type],
        description: [field.schema.description],
        widget: this._fb.group({
          id: [field.schema.widget.id]
        })
      })
    });
    if (field.schema.items) {
      this.addCheckboxSchemaValue();
      for (let item of field.schema.items.oneOf) {
        this.addCheckboxItem(item.description, item.enum);
      }
    } 
  }

  addCheckboxItem(descVal='', enumVal=''){
    (<FormArray>this.fieldForm.get('schema').get('items').get('oneOf')).push(this.addCheckboxGroupWithValue(descVal, enumVal));
   }
 
   addCheckboxGroupWithValue(descVal, enumVal): FormGroup {
     return this._fb.group({
       description: [descVal],
       enum: [enumVal]
     })
   }
   get FormCheckboxData() { 
     return <FormArray>this.fieldForm.get('schema').get('items').get('oneOf'); 
   }
 
   changeWidget() {
     if (this.fieldForm.value.schema.widget.id=='checkbox') {
       this.addCheckboxSchemaValue();
       (<FormGroup>this.fieldForm.get('schema')).get('type').setValue('array');
     } else {
       this.ClearCheckboxSchemaValue();
       (<FormGroup>this.fieldForm.get('schema')).get('type').setValue('string');
     }
   }

   
  addCheckboxSchemaValue() {
    (<FormGroup>this.fieldForm.get('schema')).addControl('items', this._fb.group({
      type: ['string'],
      widget: this._fb.group({
        id: 'string'
      }),
      oneOf: this._fb.array([])
    }));
  }
  ClearCheckboxSchemaValue() {
    (<FormGroup>this.fieldForm.get('schema')).removeControl('items');
    this.fieldForm.updateValueAndValidity();
  }

  editField(id, i, module) {
    var field;
    field = this.createFieldBody(this.fieldForm);
    field.id = id;
    if (module == "task") {
      this.taskListService.EditField(id, this.createFieldBody(this.fieldForm))
      .subscribe(resp => {
        this.formFields[i]=field;
        this.NewSchema.emit(this.schemaService.createSchema(this.formFields));
      })
    } else 
    if (module == "poll") {
      this.pollService.EditField(id, this.createFieldBody(this.fieldForm))
      .subscribe(resp => {
        this.formFields[i]=field;
        this.NewSchema.emit(this.schemaService.createSchema(this.formFields));
      })
    }
  }
  
  addField(parentId, module) {
    if (module == "task") {
      this.taskListService.AddField(parentId, this.createFieldBody(this.fieldForm))
      .subscribe(resp=> {
        this.formFields.push(resp);
        this.fieldForm.reset();
        this.NewSchema.emit(this.schemaService.createSchema(this.formFields));
      });
    } else 
    if (module == "poll") {
      this.pollService.AddField(parentId, this.createFieldBody(this.fieldForm))
      .subscribe(resp=> {
        this.formFields.push(resp);
        this.fieldForm.reset();
        this.NewSchema.emit(this.schemaService.createSchema(this.formFields));
      })
    }
  }
  deleteField(id, i, module) {
    if (module == "task") {
      this.taskListService.DeleteField(id)
      .subscribe(resp=> {
        if (i !== -1) {
          this.formFields.splice(i, 1);
        }
        this.NewSchema.emit(this.schemaService.createSchema(this.formFields));
      });
    } else 
    if (module == "poll") {
      this.pollService.DeleteField(id)
      .subscribe(resp=> {
        if (i !== -1) {
          this.formFields.splice(i, 1);
        }
        this.NewSchema.emit(this.schemaService.createSchema(this.formFields));
      })
    }
  }

  createFieldBody(fieldForm) {
    var body = {
      name: fieldForm.value.name,
      schema: JSON.stringify(fieldForm.value.schema)
    }
    return body
  }

}
